"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { mergeAudioOperation } from "../_operations/mergeAudio";

export function MergeAudioContent() {
  return <MediaWorkspace operation={mergeAudioOperation} />;
}
